import { createStore } from 'solid-js/store';

/* The header search band (Figma "Search opened", 1436:10062). Same shape as the country
   selector's store so the header can toggle it without pulling the band's chunk in. */
const [searchPanelState, setSearchPanelState] = createStore({ isOpen: false });

/* Header buttons that open the band carry this attribute so focus can be handed back to
   the exact button when the band closes. */
export const SEARCH_PANEL_TRIGGER_ATTR = 'data-search-panel-trigger';

export const searchPanelIsOpen = () => searchPanelState.isOpen;

export const openSearchPanel = () => {
    setSearchPanelState({ isOpen: true });
};

export const closeSearchPanel = () => {
    setSearchPanelState({ isOpen: false });
};

export const toggleSearchPanel = () => {
    setSearchPanelState({ isOpen: !searchPanelState.isOpen });
};
